/**
 * Components/Home/PageLoader.vue without Vue: fake progress (it is never displayed) from
 * « loading:progress » "start", then on "end" the loader is hidden 200 ms later with its
 * <Transition name="fade"> (opacity 700 ms) and removed.
 */
import type { Emitter } from "mitt";
import { random } from "lodash-es";
import { unmountWithTransition } from "./dom";
import type { LoadingEvents } from "./animation";

export function mountPageLoader(loader: HTMLElement, emitter: Emitter<LoadingEvents>): void {
    let progress = 0;
    let show = true;

    let timeout: ReturnType<typeof setTimeout> | undefined;
    const loop = (): void => {
        // fake progress, we can't really know the real progress value. we just know when it's finished
        if (progress < 75) {
            if (timeout) clearTimeout(timeout);
            progress += 10;
            timeout = setTimeout(loop, random(400, 750));
        }
    };

    // onMounted
    emitter.on("loading:progress", (value) => {
        if (value === "end") {
            progress = 100;
            setTimeout(() => {
                if (!show) return;
                show = false;
                unmountWithTransition(loader, "fade");
            }, 200);
        } else {
            progress = 10;
            loop();
        }
    });
}
